import React from "react"
import "./index.css"
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DiffOutlined
} from "@ant-design/icons"
import { Layout, Menu, theme, Button, Space, Modal, Input, Table } from "antd"
import apiFetch from "@wordpress/api-fetch";
import { useEffect, useState } from "@wordpress/element";

const { Header, Sider, Content } = Layout

const ProfileApp = () => {
  const [collapsed, setCollapsed] = useState(false)
  const [libraryName, setLibraryName ] = useState(''); 
  const [data, setData] = useState( [] );
  const [ isLibariesUpdated, setisLibariesUpdated ] = useState( false );
  const {
    token: { colorBgContainer }
  } = theme.useToken()

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const response = apiFetch({ 
      path: 'spectra-cloud/v1/libraries',
      method: 'POST',
      data: {
        title: libraryName,
        status: 'publish',
        _wpnonce: wpApiSettings.nonce
      }
    }).then( ( res ) => {
        console.log( res );
        setisLibariesUpdated( true );
    } );

    setIsModalOpen(false);
      
  };

    useEffect( () => {

        getLibraries();

    }, [ isLibariesUpdated ] );

  const columns = [
    {
      title: "Name",
      dataIndex: "title",
      key: "title",
      render: text => <a>{text}</a>
    },
    {
      title: "Private Key",
      dataIndex: "private_key",
      key: "private_key"
    },
    {
      title: "Public Key",
      dataIndex: "public_key",
      key: "public_key"
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <a>Delete</a>
        </Space>
      )
    }
  ]

  const getLibraries = () => {

    apiFetch({ 
        path: 'spectra-cloud/v1/libraries',
        method: 'GET',
    }).then( ( res ) => {
        console.log( res );
        const newData = res.map(({ id:key, title, private_key, public_key }) => ({ key, title, private_key, public_key }));
        setData( newData );  
    } );
   };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onLibraryNameChange = ( event ) => {
    setLibraryName(event.target.value)
  }

  return (
    <Layout>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["1"]}
          items={[
            {
              key: "1",
              icon: <DiffOutlined />,
              label: "Libraries"
            }
          ]}
        />
      </Sider>
      <Layout className="site-layout">
        <Header style={{ padding: 0, background: colorBgContainer }}>
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => setCollapsed(!collapsed)
            }
          )}
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer
          }}
        >
        <div>
            <Button type="primary" onClick={showModal}>
            Add Library
            </Button>
            <Modal title="Add Library" open={isModalOpen} onOk={handleSubmit} onCancel={handleCancel}>
                <Input placeholder="Enter Library Name" value={libraryName} onChange={onLibraryNameChange}/>
            </Modal>
        </div>
        <div>
            <Table columns={columns} dataSource={data} />
        </div>
        </Content>
      </Layout>
    </Layout>
  )
}

export default ProfileApp